import * as actionType from "../actionType";

/** Max customer keys kept per map to avoid unbounded Redux state (P1 #3). */
const MAX_CUSTOMER_KEYS = 10;

/** Keep at most maxKeys entries: currentKey plus (maxKeys-1) others by insertion order. */
function pruneByCustomerKey(obj, currentKey, maxKeys) {
  const keys = Object.keys(obj);
  if (keys.length <= maxKeys) return obj;
  const kept = [currentKey];
  for (const k of keys) {
    if (k !== currentKey && kept.length < maxKeys) kept.push(k);
  }
  const next = {};
  kept.forEach((k) => (next[k] = obj[k]));
  return next;
}

const initialState = {
  isDetailPage: false,
  customerInfoList: {},
  machineInfoList: {},
  machineDetailList: {},
  utilizationMachineList: {},
};

const reducer = (state = initialState, action) => {

  let _customerInfoList = { ...state.customerInfoList };
  switch (action.type) {
    case actionType.cncChangePage:
      return {
        ...state,
        isDetailPage: action.data,
      };
    case actionType.cncSetAllCustomerInfo:
      return {
        ...state,
        customerInfoList: action.data,
      };
    case actionType.cncUpdateCustomerInfo:
      _customerInfoList[action.data.customer_id] = {
        ...action.data.customer_info,
      };
      _customerInfoList = pruneByCustomerKey(_customerInfoList, action.data.customer_id, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        customerInfoList: { ..._customerInfoList },
      };
    case actionType.cncUpdateGroupMachineInfo:
      _customerInfoList[action.data.customer_id] = {
        ..._customerInfoList[action.data.customer_id],
        groupInfo: [...action.data.groupInfo],
      };
      _customerInfoList = pruneByCustomerKey(_customerInfoList, action.data.customer_id, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        customerInfoList: { ..._customerInfoList },
      };
    case actionType.cncUpdateMachineListInfo:
      let _machineInfoList = { ...state.machineInfoList };
      _machineInfoList[action.data.customer_id] = [...action.data.machine_info];
      _machineInfoList = pruneByCustomerKey(_machineInfoList, action.data.customer_id, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        machineInfoList: { ..._machineInfoList },
      };
    case actionType.cncUpdateMachineDetailInfo:
      let _machineDetailList = { ...state.machineDetailList };
      _machineDetailList[action.data.customer_id] = [...action.data.machines];
      _machineDetailList = pruneByCustomerKey(_machineDetailList, action.data.customer_id, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        machineDetailList: { ..._machineDetailList },
      };
    case actionType.utilizationData:
      let _utilizationMachineList = { ...state.utilizationMachineList };
      _utilizationMachineList[action.data.customer_id] = [...action.data.machines];
      _utilizationMachineList = pruneByCustomerKey(_utilizationMachineList, action.data.customer_id, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        utilizationMachineList: { ..._utilizationMachineList },
      };
    default:
      return state;
  }
};
export default reducer;
